module.exports = __webpack_public_path__ + "img/p24.01c96100.gif";